<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Tartoro',
  created() {
    document.title = 'Tartoro - Business Formation Made Simple'
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Nunito+Sans:wght@400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
}

body {
  min-height: 100vh;
  background-color: #FAFAFA;
}
</style>